import { css } from '@emotion/core';
import { typography } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';

export const selectContainer = css({
  position: 'relative',
  display: 'inline-block',
  marginRight: 12,
});

export const phoneNumberContainer = css({
  alignItems: 'center',
  background: colorsPalette.white,
  border: `1px solid ${colorsPalette.grey20}`,
  borderRadius: 2,
  display: 'flex',
  flexWrap: 'wrap',
  minHeight: 64,
  padding: '17px 16px',
  position: 'relative',

  '&[data-shrink="true"]': {
    padding: '10px 16px',
  },

  '&[data-focus="true"]': {
    border: `1px solid ${colorsPalette.teal}`,
  },

  '&[data-error="true"]': {
    border: `1px solid ${colorsPalette.red120}`,
  },
});

export const flagArrowContainer = css({
  zIndex: 2,
  position: 'relative',
  background: colorsPalette.white,
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'baseline',
});

export const inputCss = css(typography.effra18, {
  flex: 1,
  border: 'none',
  background: colorsPalette.transparent,
  outline: 'none',
  padding: 0,
  margin: 0,
  marginLeft: 4,
  [MediaQueries.sm]: {
    minWidth: 80,
  },

  // hide input number spin
  '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button ': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  MozAppearance: 'textfield',
});

export const iconCss = css({
  position: 'static',
  marginLeft: 6,
  fontSize: 7,
  fontWeight: 'bold',
});

export const labelCss = css(typography.effra18, {
  bottom: 0,
  color: colorsPalette.grey60,
  left: 12,
  overflow: 'visible',
  pointerEvents: 'none',
  position: 'relative',
  whiteSpace: 'nowrap',
  width: 0,
  '&[data-shrink="true"]': {
    display: 'none',
  },
});

export const numberPlaceholder = css(typography.effra18, {});

export const imageContainer = css({
  width: 28,
  height: 16,
  display: 'inline-block',
  position: 'relative',
  overflow: 'hidden',
});

export const shrinkPlaceholder = css(typography.effra12, {
  width: '100%',
  color: colorsPalette.grey80,

  '&[data-shrink="false"]': {
    display: 'none',
  },

  '&[data-focus="true"]': {
    color: colorsPalette.teal,
  },

  '&[data-error="true"]': {
    color: colorsPalette.red120,
  },
});

export const imageCss = css({
  borderRadius: 2,
  //delete below properties after integration
  width: '100%',
  height: 'auto',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});
